const getInitialValues = () => {
  return {
    dkxNumber: '',
    customerData: {
      companyName: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      address: {
        street: '',
        houseNumber: '',
        zipCode: '',
        city: '',
        countryCode: 'DE',
      },
      contactData: {
        email: '',
        mobilePhoneCountryCode: '',
        mobilePhoneNumber: '',
      },
    },
    companyData: {
      entityLegalForm: '',
      name: '',
    },
  }
}

export default getInitialValues
